import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedMaterialModule } from '../shared-material.module';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SharedDirectivesModule } from '../directives/shared-directives.module';

// ONLY REQUIRED FOR **SIDE** NAVIGATION LAYOUT
import { HeaderSideComponent } from './header-side/header-side.component';
import { SidebarSideComponent } from './sidebar-side/sidebar-side.component';

// ONLY REQUIRED FOR **TOP** NAVIGATION LAYOUT
import { HeaderTopComponent } from './header-top/header-top.component';
import { SidebarTopComponent } from './sidebar-top/sidebar-top.component';

// ALWAYS REQUIRED
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { SidenavComponent } from './sidenav/sidenav.component';

import {
	HostBooksSidebarComponent,
	HostBooksSidebarTogglerDirective,
} from './hostbooks-sidebar/hostbooks-sidebar.component';

// AutoITR POPUP
import { AutoitrComponent } from './autoitr/autoitr.component';
import { CompareCalculatorComponent } from './compare-calculator/compare-calculator.component';

const components = [
	HeaderTopComponent,
	SidebarTopComponent,
	SidenavComponent,
	SidebarSideComponent,
	HeaderSideComponent,
	AdminLayoutComponent,
	AuthLayoutComponent,
	HostBooksSidebarComponent,
	HostBooksSidebarTogglerDirective,
	AutoitrComponent,
	CompareCalculatorComponent
];

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		RouterModule,
		TranslateModule,
		FlexLayoutModule,
		PerfectScrollbarModule,
		SharedDirectivesModule,
		SharedMaterialModule
	],
	declarations: components,
	entryComponents: [],
	exports: components,
})
export class SharedComponentsModule {}
